// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"230ad46b","340":"230ad46b"}[chunkId] + ".chunk.css";
};